<template>
    <div id="app">
        <nav-bar />
        <banner />
        <benefits />
        <notice/>
        <opening />
        <location />
        <prices />
        <post-code />
    </div>
</template>

<script>
    import Notice from "./components/Notice.vue";
    import NavBar from './components/NavBar.vue';
    import Banner from './components/Banner.vue';
    import Benefits from './components/Benefits.vue';
    import Location from './components/Location.vue';
    import Prices from './components/Prices.vue';
    import PostCode from './components/PostCode.vue';
    import Opening from './components/Opening.vue';

    export default {
        name: 'app',
        components: {
            NavBar,
            Banner,
            Benefits,
            Location,
            Prices,
            Opening,
            PostCode,
            Notice
        }
    }

</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .section {

        padding: 0 !important;

    }

</style>
